// Iter 303 — blue attention pill for items / deals billed for the first time
// on the statement being viewed.
export function NewPill({ kind = "item", first = "", className = "", testId }) {
  const deal = kind === "deal";
  const title = deal
    ? "New deal — this customer's first month on a commission statement"
    : `New item — first billed ${first || "this month"}`;
  return (
    <span data-testid={testId}
      className={`inline-flex items-center rounded-full bg-blue-100 px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-blue-700 ring-1 ring-inset ring-blue-200 ${className}`}
      title={title}>
      {deal ? "new deal" : "new"}
    </span>
  );
}
